import { useEffect, useMemo } from "react";
import { SelectSearch, Form } from "@telluscompany/design-system";
import { useForm } from "react-hook-form";
import { useLocalization } from "@i18n";
import { ListClientsResponse, useClientsQuery } from "../../api/client";

interface ClientSelectorProps {
  onSelect: (clientId: string | null) => void;
}

interface ClientSelectorForm {
  clientId: string;
}

export const ClientSelector = ({ onSelect }: ClientSelectorProps) => {
  const { translate } = useLocalization();
  const { data: clientsData, isLoading } = useClientsQuery({ limit: 100 });

  const clientOptions = useMemo(
    () =>
      clientsData?.data?.map((client: ListClientsResponse) => ({
        label: client.name,
        value: client.id,
      })) ?? [],
    [clientsData],
  );

  const form = useForm<ClientSelectorForm>({
    defaultValues: {
      clientId: "",
    },
  });

  const clientId = form.watch("clientId");

  useEffect(() => {
    onSelect(clientId || null);
  }, [clientId, onSelect]);

  return (
    <Form {...form}>
      <form>
        <div className="w-3/5 pt-3 pl-4">
          <SelectSearch
            control={form.control}
            label={translate("management.structures.form.label.client")}
            name="clientId"
            placeholder={translate(
              "management.structures.form.placeholder.clientSelect",
            )}
            options={clientOptions}
            disabled={isLoading}
            clearable
          />
        </div>
      </form>
    </Form>
  );
};
